import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin/dashboard");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-5">
      <div className="w-full max-w-md border border-zinc-200 bg-white">
        <div className="border-b border-zinc-200 p-8 text-center">
          <img src="/genesis-mark-v2.png" alt="Genesis IT Solution logo" className="mx-auto h-12 w-auto" />
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-zinc-900">Admin Panel</h1>
          <p className="mt-1 text-sm text-zinc-500">Sign in to manage your website</p>
        </div>
        <form onSubmit={submit} className="space-y-4 p-8">
          <div>
            <label className="font-mono-label text-[11px] text-zinc-500">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full border border-zinc-200 px-3 py-2.5 text-sm outline-none focus:border-klein" placeholder="admin@vertexit.com" />
          </div>
          <div>
            <label className="font-mono-label text-[11px] text-zinc-500">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full border border-zinc-200 px-3 py-2.5 text-sm outline-none focus:border-klein" placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-accentred">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="flex w-full items-center justify-center gap-2 bg-klein px-6 py-3 text-sm font-semibold text-white hover:bg-kleindark disabled:opacity-50">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
